<template>
	<v-list-group>
		<template #activator>
			<v-list-item-content>
				<v-list-item-title class="section-title">
					Users
					<small>({{ count }})</small></v-list-item-title
				>
			</v-list-item-content>
		</template>

		<v-divider />

		<v-list-item :selectable="false" dense>
			<v-text-field
				v-model="filter"
				placeholder="Filter name"
				hide-details
				single-line
				clearable
				dense
			/>
		</v-list-item>

		<v-list-item
			v-if="$can('addUser', 'AccessGroups')"
			:selectable="false"
			dense
		>
			<v-spacer />

			<v-btn
				v-if="!showRemove"
				text
				outlined
				small
				color="warm-blue"
				@click="$emit('add:user')"
			>
				Add Users
				<v-icon right small>fa-plus</v-icon>
			</v-btn>

			<template v-else>
				<v-btn
					text
					outlined
					small
					color="orange"
					@click="$emit('remove:users')"
				>
					Remove {{ selected.length }}
					<v-icon right small>far fa-trash-alt</v-icon>
				</v-btn>
				<v-btn text small color="ocean" @click="$selected = []"> Cancel </v-btn>
			</template>

			<v-spacer />
		</v-list-item>

		<v-list-item-group v-model="$selected" multiple>
			<v-list-item
				v-for="item in items"
				:key="item.guid"
				:value="item.guid"
				:style="{ display: display(item) }"
				dense
			>
				<v-list-item-content>
					<v-list-item-title>{{
						item.displayName || item.email
					}}</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
		</v-list-item-group>
	</v-list-group>
</template>

<script>
import _ from "lodash";

export default {
	props: {
		items: { type: Array, default: null },
		selected: { type: Array, required: false, default: () => [] },
	},

	data: () => ({
		filter: null,
	}),

	computed: {
		$selected: {
			get() {
				return this.selected;
			},
			set(value) {
				this.$emit("update:selected", value);
			},
		},

		count() {
			return _.size(this.items);
		},

		showRemove() {
			return !!_.size(this.selected);
		},
	},

	methods: {
		display(item) {
			if (
				!_.isEmpty(this.filter) &&
				!_.includes(_.toLower(item.displayName), _.toLower(this.filter)) &&
				!_.includes(_.toLower(item.email), _.toLower(this.filter))
			)
				return "none";
		},
	},
};
</script>
